<template>
  <div>
    <v-overlay absolute v-if="statusLive === false" style="backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
      <v-chip
  outlined disabled x-large
  label
  style="opacity: 1; border-color: rgba(255,255,255,0.8); padding: 0 2rem;"
>Live is ended</v-chip>
      
    </v-overlay>
    <div class="mb-6">
      <div class="headline font-weight-black streamkey-header">StreamKey</div>
    </div>
    <v-row>
      <v-col>
        <div class="mb-6">
          <div class="font-weight-bold title">URL Server</div>
          <v-row>
            <v-col :cols="8" :lg="10" :md="10" :sm="8">
              <div class="box-disable">
                {{ statusLive !== false ? urlServer:'' }}
              </div>
            </v-col>
            <v-col :cols="4" :lg="2" :md="2" :sm="4">
              <div>
                <v-btn
                  class="d-flex align-center white-text-btn btnCopy"
                  color="#50ADDE"
                  elevation="0"
                  @click="copyToClipBoard(urlServer)"
                  >Copy</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mb-6">
          <div class="font-weight-bold title">Stream Key</div>
          <v-row>
            <v-col :cols="8" :lg="10" :md="10" :sm="8">
              <div class="box-disable">
                {{ statusLive !== false ? streamKey:'' }}
              </div>
            </v-col>
            <v-col :cols="4" :lg="2" :md="2" :sm="4">
              <v-btn
                class="d-flex align-center white-text-btn btnCopy"
                elevation="0"
                color="#50ADDE"
                @click="copyToClipBoard(streamKey)"
                >Copy</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col> </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    displayName: {
      type: String,
    },
    displayImage: {
      type: String,
    },
    startTime: {
      type: Number,
    },
    endTime: {
      type: Number,
    },
    urlServer: {
      type: String,
    },
    streamKey: {
      type: String,
    },
    statusLive: {
      type: Boolean,
    },
  },
  async mounted() {
    console.log(this.urlServer);
  },
  watch: {
    urlServer(value) {
      console.log("----",value);
    },
    streamKey(value) {
      console.log("StreamKey",value)
    }
  },
  methods: {
    copyToClipBoard(text) {
      navigator.clipboard.writeText(text);
    },
  },
};
</script>
<style scoped>
.description {
  font-size: 16px;
}
.chat-avatar {
  padding: 10px 10px 10px 0px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
.white-text-btn {
  color: white;
}
.title {
  font-size: 16px !important;
}
.btnCopy {
  border-radius: 0px !important;
}
.streamkey-header {
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
</style>